import Vue from 'vue'
import Vuex from 'vuex'
import http from '../services/http'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: window.localStorage.getItem('sandbox.token') || '',
    currentUser: JSON.parse(window.localStorage.getItem('sandbox.user') || 'null'),
    currentRole: null,
    loading: false
  },
  mutations: {
    setCurrentUser (state, user) {
      state.currentUser = user
    },
    setCurrentRole (state, role) {
      state.currentRole = role
    },
    setAuth (state, payload) {
      state.token = payload.token
      state.currentUser = payload.user
      state.currentRole = payload.user && payload.user.role
      window.localStorage.setItem('sandbox.token', payload.token)
      window.localStorage.setItem('sandbox.user', JSON.stringify(payload.user))
    },
    clearAuth (state) {
      state.token = ''
      state.currentUser = null
      state.currentRole = null
      window.localStorage.removeItem('sandbox.token')
      window.localStorage.removeItem('sandbox.user')
    }
  },
  getters: {
    isAuthenticated: state => Boolean(state.token && state.currentUser),
    role: state => state.currentUser ? state.currentUser.role : ''
  },
  actions: {
    async refreshCurrentUser ({ commit, state }) {
      if (!state.token) return null
      const response = await http.get('/auth/me')
      const user = response.data.data
      commit('setAuth', { token: state.token, user })
      return user
    },
    async login ({ commit }, credentials) {
      const response = await http.post('/auth/login', credentials)
      const data = response.data.data
      commit('setAuth', data)
      return data.user
    },
    async logout ({ commit }) {
      try {
        await http.post('/auth/logout')
      } finally {
        commit('clearAuth')
      }
    }
  }
})
